import { useEffect, useRef, useState } from "react";
import "./App.css";
import JSConfetti from "js-confetti";
import { getFingerprint } from "@thumbmarkjs/thumbmarkjs";
import { ip, postAPI } from "./api/api";
import HandleAssessment from "./components/embed/HandleAssessment";
import PreventPullToRefresh from "./components/stopRefresh";



export default function Embed2() {
  const [elearningInformation, setElearningInformation] = useState({});
  const [embedStructure, setEmbedStructure] = useState([]);
  const [embedPage, setEmbedPage] = useState("loading");
  const [currentAssessment, setCurrentAssessment] = useState(0);
  const [embedBtnState, setEmbedBtnState] = useState(0);

  const [quizStructure, setQuizStructure] = useState([]);
  
  const embedIdMatch = window.location.href.match(/\/embed\/([^\/?#]+)/);
  const ccRegex = window.location.href.match(/(?:^|[?&])cc=([^&]+)/)
  const pcRegex = window.location.href.match(/(?:^|[?&])pc=([^&]+)/);
  const id = embedIdMatch ? embedIdMatch[1] : null;



  useEffect(() => {
    getEmbedId();
  }, []);
  useEffect(() => {
    if (embedPage !== "assessment") return;
    const LS_CA = JSON.parse(localStorage.getItem(`embed_${id}`));
    localStorage.setItem(`embed_${id}`, JSON.stringify({ ...LS_CA, current_module: currentAssessment }));


  }, [currentAssessment]);

  useEffect(() => {
    if (!Array.isArray(embedStructure)) return;


  }, [embedStructure, elearningInformation?.title]);



  const changeFavicon = (src) => {
    let link = document.querySelector("link[rel*='icon']") || document.createElement("link");
    link.type = "image/x-icon";
    link.rel = "icon";
    link.href = src;
    document.head.appendChild(link);
  };

  const embedReady = (title) => {
    let currentTimeout;
    document.title = title;
    document.addEventListener("visibilitychange", function() {
      if (document.hidden) {
        currentTimeout = setTimeout(() => {
          document.title = "Wacht! Je mist iets waardevols";
          changeFavicon("/warning.ico")
        }, 5000)
      } else {
        clearTimeout(currentTimeout)
        document.title = title;
        changeFavicon("/favicon.ico")
      }
    });
  };

  const getDeviceFP = async () => {
    try { return (await getFingerprint({ logging: false })).hash } catch { return "1"; }
  };






  const getEmbedId = async () => {
    if (!embedIdMatch || !id) return setEmbedPage("not_found");
    try {
      const embed_information = await (await fetch(`${ip}/api/embed/${id}/information`)).json();
      if (embed_information?.data?.title) {
        setElearningInformation(embed_information.data);
        setEmbedPage("start");
        embedReady(embed_information.data.title);
        interactionEmbed("opened_embed")
      } else setEmbedPage("not_found");
    } catch (err) { console.error("getEmbedId error", err); setEmbedPage("not_found"); }
  };


  const interactionEmbed = async (interaction_type) => {
    const query = `api/science/interactions`;
    const body = {
      "id_course": id,
      "interaction": interaction_type,
      "device_token": await getDeviceFP()

    }
    if(pcRegex) body.pc = pcRegex[1]
    if(ccRegex) body.cc = ccRegex[1]

   await postAPI(query, body);
  }


  return (
    
    <div style={{ width: "100%", height: "100dvh" }}>
      <HandleAssessment
        embedPage={embedPage}
        elearningInformation={elearningInformation}
        embedBtnState={embedBtnState}
        startEmbedAssessment={() => setEmbedPage("assessment")}
        id={id}
        embedStructure={embedStructure}
        currentAssessment={currentAssessment}
        setEmbedStructure={setEmbedStructure}
        setCurrentAssessment={setCurrentAssessment}
        setFinished={() => setEmbedPage("finished")}
        interactionEmbed={async (action) => await  interactionEmbed(action)}
        quizStructure={quizStructure}
        setQuizStructure={setQuizStructure}
      />
    </div>
    
  );
}
